import PropTypes from "prop-types";

export default PropTypes.shape({
  tabName: PropTypes.string,
  conferenceId: PropTypes.number,
  clientId: PropTypes.number,
  sport: PropTypes.number,
  text: PropTypes.string,
  eventType: PropTypes.number,
  category: PropTypes.number,
  sStartDate: PropTypes.instanceOf(Date), // Scheduled start date
  sEndDate: PropTypes.instanceOf(Date), // Scheduled end date
  oStartDate: PropTypes.instanceOf(Date), // On Demand start date
  oEndDate: PropTypes.instanceOf(Date) // On Demand end date
});
